import Kendra from 'aws-sdk/clients/kendra';
import * as React from 'react';
import { attributeValueToString } from '../utils';
import { Facet } from './Facet';
import { SelectedFacetRetriever } from '../SelectedFacetRetriever';

interface Props {
    attributeName: string;
    disableAdd: boolean;
    valueCountPairs: Kendra.DocumentAttributeValueCountPair[];

    facetConfiguration: {
        facetsToShowWhenUncollapsed: number;
        showCount: boolean;
    };

    onSelectionChange: (
        key: Kendra.DocumentAttributeKey,
        value: Kendra.DocumentAttributeValue,
        changeDetail: boolean
    ) => void;

    onClear: (key: Kendra.DocumentAttributeKey) => void;

    selectedFacets?: SelectedFacetRetriever;
}

export const StringFacet = ({
    attributeName,
    disableAdd,
    facetConfiguration,
    valueCountPairs,
    onSelectionChange,
    onClear,
    selectedFacets,
}: Props) => {
    return (
        <Facet
            attributeName={attributeName}
            values={valueCountPairs.map((value) => ({
                ...value,
                ValueLabel: attributeValueToString(
                    value.DocumentAttributeValue
                ),
            }))}
            disableAdd={disableAdd}
            facetConfiguration={facetConfiguration}
            onSelectionChange={onSelectionChange}
            onClear={onClear}
            selectedFacets={selectedFacets}
        />
    );
};
